import { useDropzone } from "react-dropzone";
import React, { useCallback, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { RiDeleteBin7Line } from "react-icons/ri";

interface IFileDropzoneProps {
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
}

const FileDropzone: React.FC<IFileDropzoneProps> = ({ setFiles }) => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      setUploadedFiles((prev) => [...prev, ...acceptedFiles]);
      setFiles((prev) => [...prev, ...acceptedFiles]);
    },
    [setFiles],
  );

  const handleRemoveFile = (file: File) => {
    setUploadedFiles((prev) => prev.filter((f) => f !== file));
    setFiles((prev) => prev.filter((f) => f !== file));
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "application/pdf": [".pdf"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
      "application/msword": [".doc", ".dot"],
      "application/rtf": [".rtf"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
      "image/*": [".png", ".jpg", ".jpeg", ".tiff", ".tif"],
      "text/*": [".txt", ".md"],
      "application/json": [".json"],
      "text/csv": [".csv"],
      "application/xml": [".xml"],
    },
    multiple: true,
  });

  return (
    <div className="mt-1">
      <div
        {...getRootProps()}
        className="border border-dashed border-gray-400 p-6 text-center rounded-md bg-gray-300 dark:bg-gray-900 text-black dark:text-white cursor-pointer"
      >
        <input {...getInputProps()} />
        <p className="mb-2">Click or drag files to this area to upload</p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Accepted files: .docx, .rtf, .doc, .xls, .xlsx, .dot, .csv, .xml,
          .json, .txt, .pdf.
        </p>
      </div>

      {uploadedFiles.length > 0 && (
        <div className="mt-4 max-h-52 overflow-y-auto">
          <ul>
            {uploadedFiles.map((file, index) => (
              <li
                key={index}
                className="flex items-center justify-between mb-2 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded"
              >
                <span className="text-sm text-base-color">{file.name}</span>
                <button
                  type="button"
                  onClick={() => handleRemoveFile(file)}
                  className="text-del-red hover:text-red-700"
                >
                  <RiDeleteBin7Line
                    size={16}
                    className="text-del-red focus:outline-none"
                  />
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export { FileDropzone };
